import React from 'react';
import { MoreHorizontal, Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const Header = ({ title, onMenuClick }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <header className="h-16 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700 flex items-center justify-between px-4 lg:px-8 sticky top-0 z-10 transition-colors">
      <div className="flex items-center">
        <button
          type="button"
          onClick={onMenuClick}
          className="p-2 mr-4 text-gray-600 dark:text-gray-400 lg:hidden hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg"
          aria-label="Open menu"
        >
          <MoreHorizontal size={24} />
        </button>
        <h1 className="text-xl font-semibold text-gray-800 dark:text-gray-100">{title}</h1>
      </div>

      <button
        type="button"
        onClick={toggleTheme}
        className="p-2 text-gray-500 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-full transition-colors"
        aria-label="Toggle dark mode"
      >
        {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
      </button>
    </header>
  );
};

export default Header;
